<template lang="html">
	<div :class="[sticky ? 'mainNav sticky-nav' : 'mainNav']">
		<nav class="navbar navbar-light fixed-top">
			<div class="navbar-container">
				<slot name="logo"></slot>
				<div @click="MenuToggler">
					<slot name="toggler"></slot>
				</div>
				<slot></slot>
			</div>
		</nav>
	</div>
</template>

<script>

export default {

	name: 'MainNav',

	data() {
		return {
			sticky: false,
			menuToggled: false,
		}
	},
	mounted() {
		this.$root.$on('scroll', this.checkScroll)
		this.$root.$on('yoffset', this.checkScroll)
		this.$root.$on('resize', this.checkSize)
		this.setNavHeight()
		if(this.menuToggled) {
			document.addEventListener('touchmove', this.preventDefault, { passive: false }, false)
		} else {
			document.removeEventListener('touchmove', this.preventDefault, { passive: false }, false)
		}
		window.addEventListener('resize', this.setNavHeight);
	},

	methods: {

		checkScroll(top) {
			let navbar = document.getElementsByClassName('mainNav');
			let sticky = navbar[0].offsetTop;
			this.sticky = (top > sticky) ? true : false
		},

		checkSize(width, height) {
			if(width > 1024) {
				this.menuClose()
			}
		},

		MenuToggler() {
			this.setNavHeight()
			if(!this.menuToggled) {
				this.menuOpen()
			} else {
				this.menuClose()
			}
		},

		setNavHeight() {
			document.getElementById('navbar-nav').style.height = window.innerHeight+'px'
		},

		preventDefault(e) {
			e.preventDefault()
		},

		menuOpen() {
			document.getElementById('app').classList.add("no-scroll")
			document.getElementById('app').classList.add("nav-open")
			document.body.classList.add("no-scroll")
			document.getElementById('sticky-search').classList.add("d-flex")
			this.menuToggled = true
		},

		menuClose() {
			document.getElementById('app').classList.remove("no-scroll")
			document.getElementById('app').classList.remove("nav-open")
			document.body.classList.remove("no-scroll")
			document.getElementById('sticky-search').classList.remove("d-flex")
			this.menuToggled = false
		},

	}
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/MainNav.vue